document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		$('div.swiper').attr({
			role: 'region',
			'aria-label': 'Carousel',
		});
		$('.blog-articles .blog__filters h4').attr({ role: 'none' });
		$('div.sidebar-articles > h4').attr({
			role: 'heading',
			'aria-level': '2',
		});
		$('.sidebar-articles > a h4').attr({ role: 'none' });

		$('.yotpo-reviews-star-ratings-widget').each(function () {
			$(this).find('.star-container svg').removeAttr('tabindex');
		});

		$(
			'.yotpo-sr-bottom-line-right-panel .yotpo-sr-bottom-line-text',
		).removeAttr('tabindex');

		console.log('loaded');
	}, 1000);
	const ImageAlt = [
		{
			name: 'brides-logo.png',
			alt: 'Brides Logo',
		},
		{
			name: 'byrdie-logo.png',
			alt: 'BYRDIE Logo',
		},
		{
			name: 'LOGO_THE_KNOT.svg',
			alt: 'The Knot Logo',
		},
		{
			name: 'coveteur-logo.png',
			alt: 'Coveteur Logo',
		},
	];
	ImageAlt.forEach((image) => {
		if ($(`img[src*="${image.name}"]`).attr('alt') !== '') return;
		$(`img[src*="${image.name}"]`).attr({
			alt: image.alt,
		});
	});
	const Decoratives = [
		'find-your-fit-large.jpg',
		'find-your-fit-small.jpg',
		'get-in-touch.jpg',
	];
	Decoratives.forEach((image) => {
		$(`img[src*="${image}"]`).attr({
			alt: '',
		});
	});
});
